import type { Receipt } from "~/lib/matrix";

type Identifiable = { id: string };

export function latestReceiptPerUser(
  events: readonly Identifiable[],
  receiptsFor: (eventId: string) => Receipt[],
): Map<string, Receipt[]> {
  const placed = new Set<string>();
  const result = new Map<string, Receipt[]>();
  for (let i = events.length - 1; i >= 0; i -= 1) {
    const event = events[i];
    if (!event) continue;
    const received = receiptsFor(event.id);
    if (received.length === 0) continue;
    const kept: Receipt[] = [];
    for (const receipt of received) {
      if (placed.has(receipt.userId)) continue;
      placed.add(receipt.userId);
      kept.push(receipt);
    }
    if (kept.length > 0) result.set(event.id, kept);
  }
  return result;
}

export function lastReceiptableEvent(events: readonly Identifiable[]): Identifiable | null {
  for (let i = events.length - 1; i >= 0; i -= 1) {
    const event = events[i];
    if (!event) continue;
    if (!event.id.startsWith("$local-")) return event;
  }
  return null;
}
